const LoadingBox = () => {
    return (
        < >
            <div className="spinner-border avatar-lg text-primary m-3" role="status"></div>

        </ >
    )
}

export default LoadingBox